import { Link } from '@chakra-ui/next-js';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { storeLinks } from '../lib/storeLinks';

const StoreLinks: FC<{ onClick?: () => void }> = ({ onClick }) => {
  const { asPath } = useRouter();
  const { t } = useTranslation();

  return (
    <>
      {storeLinks.map(({ href, name, isTranslationKey }) => {
        const isActive = asPath === href;
        const displayName = isTranslationKey ? t(name) : name;

        return (
          <Link
            key={name}
            fontWeight={isActive ? 'semibold' : 'normal'}
            href={href}
            onClick={() => onClick?.()}
          >
            {displayName}
          </Link>
        );
      })}
    </>
  );
};

export default StoreLinks;
